import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { setDefaultOptions } from 'date-fns';
import { enUS, fi } from 'date-fns/locale';

// Import translations
// Directly import JSON files
import enTimesheet from './locales/en/timesheet.json';
import enApproval from './locales/en/approval.json';
import fiTimesheet from './locales/fi/timesheet.json';
import fiApproval from './locales/fi/approval.json';
import enCommon from './locales/en/common.json';
import fiCommon from './locales/fi/common.json';

export const languageMapping = {
    en: {
        label: 'English',
        locale: enUS,
    },
    fi: {
        label: 'Finnish',
        locale: fi,
    },
};

const defaultLanguage = 'en';

// Initialize i18next
i18n.use(initReactI18next).init(
    {
        resources: {
            en: {
                timesheet: enTimesheet,
                approval: enApproval,
                common: enCommon,
            },
            fi: {
                timesheet: fiTimesheet,
                approval: fiApproval,
                common: fiCommon,
            },
        },
        lng: defaultLanguage, // Default language
        fallbackLng: defaultLanguage,
        ns: ['timesheet', 'approval', 'common'], // Define namespaces here
        defaultNS: 'common', // Default namespace if needed
        interpolation: {
            escapeValue: false,
        },
    },
    (err, t) => {
        // Callback after initialization to update moment locale
        if (!err) {
            setDefaultOptions({ locale: languageMapping[defaultLanguage].locale });
        }
    },
);

// Set moment locale to match i18n language
i18n.on('languageChanged', lng => {
    setDefaultOptions({ locale: languageMapping[lng].locale });
});

export default i18n;
